// Password strength evaluation shared across all set-password screens.
// Policy mirrors the backend: min 8 chars AND at least 3 of 4 character classes.

export function evaluatePassword(pw) {
  pw = pw || "";
  const checks = {
    length: pw.length >= 8,
    lower: /[a-z]/.test(pw),
    upper: /[A-Z]/.test(pw),
    digit: /\d/.test(pw),
    symbol: /[^A-Za-z0-9]/.test(pw),
  };
  const classes = ["lower", "upper", "digit", "symbol"].filter((k) => checks[k]).length;
  const valid = checks.length && classes >= 3;
  // score 0-4 for the meter
  let score = 0;
  if (pw.length >= 8) score += 1;
  if (pw.length >= 12) score += 1;
  score += Math.max(0, classes - 1);
  score = Math.min(4, score);
  if (pw.length === 0) score = 0;
  return { score, valid, classes, checks };
}

const LABELS = ["Too weak", "Weak", "Fair", "Good", "Strong"];
const COLORS = ["bg-alert", "bg-alert", "bg-amber-500", "bg-emerald-500", "bg-emerald-600"];

export function PasswordStrength({ value }) {
  if (!value) return null;
  const { score, valid, checks } = evaluatePassword(value);
  return (
    <div className="mt-2" data-testid="password-strength">
      <div className="flex gap-1">
        {[0, 1, 2, 3].map((i) => (
          <div key={i} className={`h-1.5 flex-1 rounded-full transition-colors ${i < score ? COLORS[score] : "bg-border"}`} />
        ))}
      </div>
      <div className="flex items-center justify-between mt-1.5">
        <span className={`text-xs font-medium ${valid ? "text-emerald-600" : "text-muted-foreground"}`} data-testid="password-strength-label">
          {LABELS[score]}
        </span>
        {!valid && (
          <span className="text-[11px] text-muted-foreground">8+ chars, 3 of 4 types</span>
        )}
      </div>
      {!valid && (
        <div className="flex flex-wrap gap-x-3 gap-y-0.5 mt-1 text-[11px] text-muted-foreground">
          <Req ok={checks.length} label="8+ characters" />
          <Req ok={checks.upper} label="uppercase" />
          <Req ok={checks.lower} label="lowercase" />
          <Req ok={checks.digit} label="number" />
          <Req ok={checks.symbol} label="symbol" />
        </div>
      )}
    </div>
  );
}

function Req({ ok, label }) {
  return <span className={ok ? "text-emerald-600" : "text-muted-foreground"}>{ok ? "✓" : "•"} {label}</span>;
}
